import { render, staticRenderFns } from "./profile-image-item.vue?vue&type=template&id=e03400b0&scoped=true&"
import script from "./profile-image-item.vue?vue&type=script&lang=js&"
export * from "./profile-image-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e03400b0",
  null
  
)

export default component.exports